import { useEffect, useRef } from 'react';

export default function FooterBar() {
  const year = new Date().getFullYear();
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            (entry.target as HTMLElement).style.opacity = '1';
            (entry.target as HTMLElement).style.transform = 'translateY(0)';
          }
        });
      },
      { threshold: 0.5 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <footer
      ref={ref}
      className="bg-stone-100 border-t border-zinc-200 transition-all duration-700"
      style={{ opacity: 0, transform: 'translateY(16px)' }}
    >
      <div className="max-w-7xl mx-auto px-8 py-8 flex flex-col sm:flex-row items-center justify-between gap-4">
        <span
          className="text-zinc-800 font-bold tracking-widest text-sm whitespace-nowrap"
          style={{ fontFamily: "'Space Grotesk', sans-serif" }}
        >
          BORVIL OOD
        </span>
        <p className="text-zinc-500 text-xs text-center" style={{ fontFamily: "'Inter', sans-serif" }}>
          &copy; {year} BORVIL OOD. All rights reserved. Plovdiv, Bulgaria.
        </p>
        <div className="flex items-center gap-2 text-zinc-500 text-xs" style={{ fontFamily: "'Inter', sans-serif" }}>
          <i className="ri-apple-line text-zinc-400"></i>
          <span>iOS Application Development</span>
        </div>
      </div>
    </footer>
  );
}
